import { useEffect, useRef, useState } from "react";
import api from "../../../services/api";
import jsPDF from 'jspdf';
import { Button, Card, Col, Modal as Modals, Row, Modal as ModalBoot } from 'react-bootstrap';
import { Autocomplete, Modal, Box, LinearProgress, TextField, Typography, Tooltip } from '@mui/material';
import { Label } from '../../Label';
import { useNavigate } from 'react-router-dom';
import AlertMessage from "../../Alert";

interface ModalAsoProps {
    idEmpresa: any | null,
    show: boolean;
    onHide: () => void;
}

export const ModalAsoTrabalhador: React.FC<ModalAsoProps> = ({ idEmpresa, show, onHide }) => {
    const [uploadFiles, setUploadFiles]: any = useState([]);
    const [trabalhadoresModal, setTrabalhadoresModal]: any = useState([])
    const [trabalhadorModalSelecionado, setTrabalhadorModalSelecionado]: any = useState()
    const [showAttachModal, setShowAttachModal] = useState(false);
    const [examData, setExamData]: any = useState([]);
    const [progressModalOpen, setProgressModalOpen] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState("");
    const [funcoesSelecionadas, setFuncoesSelecionadas]: any = useState([]);
    const [isDisabled, setIsDisabled] = useState(true);
    const [reaproveitamento, setReaproveitamento] = useState()
    const [progressValue, setProgressValue] = useState(0);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const uploadFilesRef = useRef<any>([]);

    const handleCloseModal = () => setShowModal(false);

    const handleNavigate = () => {
        navigate('/trabalhadores/cadastrar');
    };

    useEffect(() => {
        const fetchData = async () => {
            await handleListTrabalhadores()
        }

        fetchData()
    }, [showModal])

    const handleListTrabalhadores = async () => {
        try {
            const response = await api.get(`buscar-trabalhadores`)
            setTrabalhadoresModal(response.data)
        } catch (error) {
            console.error(error)
        }
    }

    const formatDateToStandard = (date: any) => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const handleFileUpload = async () => {
        try {
            const formData = new FormData();
            const formattedDate = formatDateToStandard(new Date());

            for (const file of uploadFilesRef.current) {
                const fileName = file.name.replace(/\.pdf$/i, `-${formattedDate}.pdf`);
                formData.append("files[]", file, fileName);
            }

            setProgressValue(0);
            simulateProgress();
            setShowAttachModal(false);
            setProgressModalOpen(true);

            // 3. Enviar todos os arquivos em uma única requisição
            const response = await api.post("/reaproveitar-aso/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            const responseData = response.data;
            let newExams: any;
            if (Array.isArray(responseData.exame)) {
                newExams = responseData.exame.map((exame: any) => ({
                    exame,
                    data: responseData.data,
                    tipo_exame: responseData.tipo_exame,
                    normas: responseData.normas,
                }));
            }
            setExamData(newExams);


            let funcoes;
            if (responseData.funcao) {
                const funcaoEncontrada = await api.get(`funcionarios/buscar-funcao/${responseData.funcao.nome}`);
                const { id, nome } = funcaoEncontrada.data[0];
                setFuncoesSelecionadas([{ id, nome }]);
                funcoes = [{ id, nome }];
            }

            // 4. Atualizar o trabalhador com os novos exames e funções
            const novoReaproveitamento = await handleUpdateWorker(newExams, funcoes);
            const data = { id: novoReaproveitamento, nomeDoPdf: `${formattedDate}.pdf` };

            // Converte os arquivos para Base64
            const base64Files = await Promise.all(
                uploadFilesRef.current.map(async (file: File) => {
                    const base64 = await readFileAsBase64(file);
                    return {
                        bytes: base64,
                        fileName: file.name.replace(/\.pdf$/i, `-${formattedDate}.pdf`),
                    };
                })
            );

            const payload = {
                bytes: base64Files.map((file) => file.bytes),
                data: {
                    nomeDoPdf: `${formattedDate}.pdf`,
                    id: novoReaproveitamento,
                },
            };

            const uploadExameResponse = await api.post('/upload-reaproveitamento-exame', payload);

            if (uploadExameResponse.status === 200) {
                setProgressValue(100);
                setProgressModalOpen(false);
                setAlert({
                    show: true,
                    message: "Arquivos enviados com sucesso!",
                    variant: "success",
                });
                setUploadFiles([]);
                uploadFilesRef.current = [];
            }
        } catch (error) {
            setProgressValue(100);
            setProgressModalOpen(false);
            setAlert({
                show: true,
                message: "Erro ao enviar os arquivos.",
                variant: "danger",
            });
        }
    };

    const readFileAsBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve((reader.result as string).split(",")[1]);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    const handleUpdateWorker = async (exams: any, funcoesSelecionadas?: any) => {
        try {
            const body = { exams, funcoesSelecionadas, trabalhadorModalSelecionado, idEmpresa };

            const response = await api.post("salvar-reaproveitamento-trabalhador", body);
            const dados = await api.get(`listar-asos-assinados-por-trabalhador/${response.data.trabalhador}`);
            const reaproveitamentoAtualizado = response.data.reaproveitamentoTrabalhador;

            return reaproveitamentoAtualizado;
        } catch (error) {
            console.error("Erro ao atualizar trabalhador:", error);
        }
    };

    const handleSaveExam = async (exams: any, funcoesSelecionadas?: any) => {
        try {
            const body = { exams, funcoesSelecionadas, trabalhadorModalSelecionado, idEmpresa };
            const response = await api.post("salvar-reaproveitamento-trabalhador", body);
            if (response.status == 200) {
                const reaproveitamentoAtualizado = response.data.reaproveitamentoTrabalhador
                setFuncoesSelecionadas([]);
                setReaproveitamento(reaproveitamentoAtualizado);
                setSelectedFileName("");
                return reaproveitamentoAtualizado
            } else {
                setAlert({
                    show: true,
                    message: "falha ao salvar reaproveitamento",
                    variant: "danger",
                });
            }

        } catch (error) {
            console.log(error);
        }
    };

    const simulateProgress = () => {
        let progress = 0;
        const interval = setInterval(() => {
            if (progress < 95) {
                progress += 13.0;
                setProgressValue(progress);
            } else {
                clearInterval(interval);
            }
        }, 800);
    };

    const handleFileSelection = async (e: any) => {
        const file = e.target.files[0];
        if (file) {
            const fileName = file.name.concat(`- ${formatDateToStandard(new Date())}`);
            let processedFile = file;

            if (file.type.startsWith("image/")) {
                const imageData = await readFileAsDataURL(file);
                const imgType = file.type === "image/png" ? "PNG" : "JPEG";

                const doc = new jsPDF({
                    orientation: "portrait",
                    unit: "mm",
                    format: "a4",
                });

                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();

                const img = new Image();
                img.src = imageData;

                img.onload = () => {
                    let imgWidth = img.width;
                    let imgHeight = img.height;

                    if (imgWidth > imgHeight) {
                        const ratio = imgHeight / imgWidth;
                        imgWidth = pageWidth;
                        imgHeight = pageWidth * ratio;
                    } else {
                        const ratio = imgWidth / imgHeight;
                        imgHeight = pageHeight;
                        imgWidth = pageHeight * ratio;
                    }

                    const x = (pageWidth - imgWidth) / 2;
                    const y = (pageHeight - imgHeight) / 2;
                    doc.addImage(imageData, imgType, x, y, imgWidth, imgHeight);
                    const pdfBlob = doc.output("blob");
                    processedFile = new File(
                        [pdfBlob],
                        fileName.replace(/\.[^/.]+$/, ".pdf"),
                        { type: "application/pdf" }
                    );
                    addFileToUploadList(processedFile);
                };
            } else {
                addFileToUploadList(file);
            }
            setSelectedFileName(fileName);
            if (isDisabled) setIsDisabled(false);
        }
    };

    const addFileToUploadList = (file: File) => {
        setUploadFiles((prevFiles: any) => {
            const updatedFiles = [...prevFiles, file];
            uploadFilesRef.current = updatedFiles;
            return updatedFiles;
        });
    };

    const readFileAsDataURL = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    const readFileAsBytes = (file: File): Promise<number[]> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                if (event.target?.result) {
                    const arrayBuffer = event.target.result as ArrayBuffer;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const bytes = Array.from(uint8Array);
                    resolve(bytes);
                } else {
                    reject(new Error('Erro ao ler o arquivo.'));
                }
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsArrayBuffer(file);
        });
    }

    return (
        <>
            <ModalBoot show={show} onHide={onHide}>
                <ModalBoot.Header closeButton>
                    <ModalBoot.Title>Cadastrar ASO do Trabalhador</ModalBoot.Title>
                </ModalBoot.Header>
                <ModalBoot.Body>
                    <Row>
                        <Label title='Trabalhador (a)' htmlFor={''} />
                        <Autocomplete
                            options={trabalhadoresModal}
                            getOptionLabel={(option) =>
                                option ? `${option.cpf} - ${option.nome}` : ""
                            }
                            value={trabalhadorModalSelecionado}
                            onChange={(event: any, newValue: any) => setTrabalhadorModalSelecionado(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    size="small"
                                    style={{ padding: '0.2rem 0.4rem', fontSize: '0.75rem' }}
                                />
                            )}
                        />
                    </Row>

                    <Row style={{ marginTop: '20px' }}>
                        {/* Input para capturar foto */}
                        <input
                            type="file"
                            id="photoInput"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleFileSelection}
                        />

                        {/* Input para selecionar PDF */}
                        <input
                            type="file"
                            id="pdfInput"
                            accept=".pdf"
                            style={{ display: "none" }}
                            onChange={handleFileSelection}
                        />

                        {/* Botões de seleção */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <label
                                htmlFor="photoInput"
                                style={{
                                    border: "2px solid #0d6efd",
                                    padding: "20px",
                                    width: "48%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    color: "#0d6efd",
                                    borderRadius: "4px",
                                }}
                            >
                                Tirar Foto
                            </label>

                            <label
                                htmlFor="pdfInput"
                                style={{
                                    border: "2px dashed #0d6efd",
                                    padding: "20px",
                                    width: "48%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    color: "#0d6efd",
                                    borderRadius: "4px",
                                }}
                            >
                                Inserir PDF
                            </label>
                        </div>

                        {/* Container para exibir arquivos selecionados */}
                        <div className="file-upload-container">
                            {uploadFiles.length > 0 && uploadFiles.map((file: any, index: number) => {
                                const fileName = file.name + ' - ' + formatDateToStandard(new Date());
                                return (
                                    <div key={index} className="file-upload-item">
                                        <div className="file-upload-name">
                                            <span>{fileName}</span>
                                        </div>
                                        <div>
                                            <button
                                                className="file-upload-button"
                                                onClick={() => setUploadFiles(uploadFiles.filter((f: any, i: number) => i !== index))}
                                            >
                                                Remover
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </Row>
                    <Row style={{ marginTop: "70px", alignItems: 'center', justifyContent: 'center' }}>
                        <Button
                            style={{
                                backgroundColor: "#02298A",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: '90%'
                            }}
                            onClick={handleFileUpload}
                            disabled={isDisabled}
                        >
                            Reaproveitar
                        </Button>
                    </Row>
                    <hr />
                    <Row>
                        <span style={{ textAlign: 'center' }}>
                            Caso não tenha encontrado o trabalhador na listagem,
                            <button onClick={handleNavigate} style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>
                                clique aqui para cadastrá-lo em nossa base.
                            </button>
                        </span>
                    </Row>
                </ModalBoot.Body>
            </ModalBoot>
            <ModalBoot
                show={progressModalOpen}
                sx={{ display: "grid", placeItems: "center" }}
                disableEscapeKeyDown={true}
            >
                <Box
                    sx={{
                        width: "500px",
                        p: 3,
                        bgcolor: "background.paper",
                        borderRadius: "5px",
                    }}
                >
                    <Typography sx={{ textAlign: "center", paddingBottom: "10px" }}>
                        Aguarde, importando documento.
                    </Typography>
                    <LinearProgress
                        variant="determinate"
                        value={progressValue}
                        sx={{ height: "5px", borderRadius: "3px" }}
                    />
                </Box>
            </ModalBoot>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    )

}